<template>
    <div class="container">
        <div class="wrapper">
            <b-icon class="icon" type="is-danger" size="is-large" icon="shield-alert-outline"/>
            <h1>ຂໍອະໄພ...ບໍ່ພົບໜ້ານີ້</h1>
            <b-button class="is-primary" icon-left="chevron-left" @click="goBack">ຍ້ອນກັບ</b-button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "PageNotFound",
        methods: {
            goBack(){
                window.history.back();
            }
        }
    }
</script>

<style scoped lang="scss">
    .container {
        display: flex;
        justify-content: center;
        align-items: center;
        height: calc(100vh - 60px);
    }

    .wrapper {
        text-align: center;

        h1 {
            padding: 20px 0;
            font-size: 24pt;
            font-weight: bold;
            color: #546e7a;
        }
    }
</style>